import { TThunkAction } from '../../types/redux';

export enum EAlertType {
  Favorites = 'favorites',
}

export interface IRequestAuthenticationParameters {
  alert?: EAlertType;
}

interface IAuthenticateEvent {
  autoRefresh?: boolean;
}

const TOPIC_USER = 'user';

export function requestAuthentication(): TThunkAction {
  return (dispatch, getState, context) => {
    const { globalEventsLogs } = context;

    globalEventsLogs.produce<Required<IAuthenticateEvent>>(TOPIC_USER, {
      type: 'authenticate',
      value: { autoRefresh: true },
    });
  };
}
